'use client';
import dynamic from 'next/dynamic';
const ReviewsBlockCustom = dynamic(() => import('@/components/Reviews/ReviewsBlockCustom'), {
  ssr: false,
});
export default function ReviewsBlockCustomClient() {
  return (
    <ReviewsBlockCustom
      id="reviews-block"
      title="Ваші відгуки роблять нас кращими"
      subtitle="Кожне ваше повідомлення — це можливість стати краще. Ми цінуємо вашу довіру та завжди готові допомогти!"
      thankYouText="Дякуємо за вашу довіру!"
    />
  );
}
